import { Container, Grid, Box, Typography } from '@mui/material'
import ListaOpcoes from '../../../../utils/listaOpcoes'
import HeaderSession from '../../../../utils/headerSession'
import SearchSolicitacaoImportacao from './searchSolicitacaoImportacao'

export default function Importacao() {
    return (
        <Container style={{ minHeight: '70vh' }}>
            <Box sx={{ display: { md: 'none' } }}>
                <HeaderSession title='IMPORTAÇÃO & EXPORTAÇÃO ' />
            </Box>

            <Grid container>
                <Grid margin={1} xs={12} md={5.7} item style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '40vh' }}>
                    <img src="/icones/Import_export.svg" alt="" width={'50%'} />
                </Grid>

                <Grid m={1} xs={12} md={5.7} item >
                    <Box width={'100%'} sx={{ display: { xs: 'none', md: 'block' } }}>
                        <HeaderSession title='IMPORTAÇÃO & EXPORTAÇÃO' />
                    </Box>

                    <Typography variant='subtitle1' fontSize={22} align="center" m={2} color={"secondary"}>
                        SOLICITAÇÃO DE AUTORIZAÇÃO PARA IMPORTAÇÃO DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE
                    </Typography>

                    {/* <ListaOpcoes nomeOpcao='Medicamentos controlados internacionalmente' link='/inspeccao-regulatoria/solicitacao/importacao/Medicamentos-controlados-internacionalmente' /> */}
                    {/* <ListaOpcoes nomeOpcao='Medicamentos controlados nacionais' link='/inspeccao-regulatoria/solicitacao/importacao/Medicamentos-controlados-nacionais' /> */}
                    <ListaOpcoes nomeOpcao='Medicamentos' link='/inspeccao-regulatoria/solicitacao/importacao/Medicamentos' />
                    <ListaOpcoes nomeOpcao='Suplemento Alimentar' link='/inspeccao-regulatoria/solicitacao/importacao/Suplemento-Alimentar' />
                    <ListaOpcoes nomeOpcao='Equipamento' link='/inspeccao-regulatoria/solicitacao/importacao/Equipamento' />
                    <ListaOpcoes nomeOpcao='Reagentes' link='/inspeccao-regulatoria/solicitacao/importacao/Reagentes-TDRs' />
                
                    <ListaOpcoes nomeOpcao='Soliçitar número de importador ?' link='/utente/solicitacao/numero-de-importador' />

                    <br />
                    <br />
                    <br />
                    <SearchSolicitacaoImportacao />
                    {/* <SelecteTipoCertificado />
                    <ListaOpcoes nomeOpcao='Cadastrar importador' link='#' /> */}
                </Grid>

            </Grid>
            <br />
        </Container>
    )
}
